import { FragmentSerializer } from "./FragmentSerializer";
import FootballState from "../../../../../sports/football/state/football-state";
import TeamSide from "../../../../../sports/football/enums/team-side";

/**
 * DEAD: is a recognised CMS token but carries no data - FootballDeadFragment
 * parses and applies nothing - so the dead ball spot rides along on SPOT:,
 * which sets possession side, ball spot and scrimmage line there. The start of
 * drive flag stays N: a dead ball consumes a down rather than opening a
 * series. No fumble token is emitted, by design.
 */
export class DeadBallFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.DeadBall;
    }

    getRawFragment(play, serializationContext, fragment) {
        // Pre-play possession: the offense keeps the ball, and on a dead ball
        // safety the possession switch has already been applied to the game
        // context by the time this runs.
        const teamSide = play.contextSnapshot?.homeTeamHasPossession
            ? TeamSide.Home
            : TeamSide.Visitor;

        const values = [
            teamSide,
            this.resolveFormattedFieldPosition(
                serializationContext,
                fragment.deadAt
            ),
            "N"
        ];

        return `DEAD: SPOT:${values.join()}`;
    }
}
